import * as React from "react";
import type { SVGProps } from "react";
const SvgBag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path d="M16.375 5.525a.425.425 0 0 0-.417-.408H12.9a3.7 3.7 0 0 0-.542-1.55A2.66 2.66 0 0 0 10 2.333 2.66 2.66 0 0 0 7.64 3.567c-.295.469-.48.999-.541 1.55H4.04a.425.425 0 0 0-.416.408l-.459 11.667a.42.42 0 0 0 .109.308.47.47 0 0 0 .308.125h12.833a.425.425 0 0 0 .392-.267.4.4 0 0 0 .025-.166zM7.94 5.117a2.8 2.8 0 0 1 .392-1.092A1.84 1.84 0 0 1 10 3.192a1.84 1.84 0 0 1 1.666.833 2.8 2.8 0 0 1 .4 1.092zM4.016 16.783 4.441 5.95h11.117l.425 10.833z" />
  </svg>
);
export default SvgBag;
